import type { LucideIcon, LucideProps } from 'lucide-react';

export type { LucideIcon };

export interface IconProps extends LucideProps {
  /** A lucide-react icon component, e.g. `import { Bell } from 'lucide-react'`. */
  icon: LucideIcon;
}

// Thin wrapper for consistent default sizing/stroke. Direct lucide imports also
// work; this just standardizes the defaults when an icon is passed as data.
export function Icon({ icon: Glyph, size = 16, strokeWidth = 2, ...rest }: IconProps): JSX.Element {
  return <Glyph size={size} strokeWidth={strokeWidth} {...rest} />;
}
